export enum APP_TYPE {
  BACKOFFICE = 'backoffice',
  FRONT_OFFICE = 'frontoffice',
  PUBLIC_OFFICE = 'publicoffice',
}
